/**
 * Подписка на медиазапрос. jsdom не реализует `matchMedia` — тогда
 * запрос считается не выполненным (как в `motion.ts`).
 */
import { useEffect, useState } from 'preact/hooks';

function query(q: string): MediaQueryList | null {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return null;
  return window.matchMedia(q);
}

export function useMediaQuery(q: string): boolean {
  const [matches, setMatches] = useState(() => query(q)?.matches ?? false);
  useEffect(() => {
    const mq = query(q);
    if (!mq) return;
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [q]);
  return matches;
}
